<template>
  <div></div>
</template>

<script>
import { getProfile } from "@/apis/auth";
import { mapActions } from "vuex";
export default {
  name: "Loading",
  data() {
    return {
      isAuthenticated: null,
      role: ""
    };
  },
  created() {
    this.isAuthenticated = localStorage.getItem("user-token");
    if (this.isAuthenticated) {
      getProfile()
        .then(res => {
          this.role = res.data.role;
          if (
            this.isAuthenticated &&
            (this.role === "admin" ||
              this.role === "assistant" ||
              this.role === "owner")
          ) {
            if (this.role === "admin") {
              this.$router.push({ name: "ViewPADirectory" });
            } else if (this.role === "assistant") {
              this.$router.push({ name: "TaskDashboard" });
            } else if (this.role === "owner") {
              this.$router.push({ name: "DedicatedCustomers" });
            }
          }
        })
        .catch(() => {
          this.actionLogoutUser()
            .then(() => {
              this.$router.push({ name: "Login" });
            })
            .catch(err => {
              console.log(err);
            });
        });
    } else {
      this.$router.push({ name: "Login" });
    }
  },
  methods: {
    ...mapActions("authModule", ["actionLogoutUser"])
  }
};
</script>

<style></style>
